export let MAX_ITEMS_PER_REQUEST = 120;

// This is only for testing purposes
export const setMaxItemsPerRequest = (quantity: number) => (MAX_ITEMS_PER_REQUEST = quantity);
